
init();

function init() {
    console.log('Hello World');
}  

/*import 'partials/navigation.js'*/